import {
  Avatar,
  AvatarFallback,
  AvatarImage,
  AvatarProps,
} from '@/components/ui/avatar';
import { Text } from '@/components/ui/text';
import { useQuery } from '@apollo/client/react';
import { CurrentUserDocument } from '~/graphql/generated/graphql';
import { Defs, LinearGradient, Stop, Svg, Rect } from 'react-native-svg';
import { cn } from '@/lib/utils';

export interface CurrentUserAvatarProps extends Partial<AvatarProps> {}

export const CurrentUserAvatar = ({
  className,
  ...props
}: CurrentUserAvatarProps) => {
  const { data } = useQuery(CurrentUserDocument);
  if (!data?.currentUser) return null;

  const initials =
    `${data.currentUser.firstName.slice(0, 1)}${data.currentUser.lastName.slice(0, 1)}`.toUpperCase();

  return (
    <Avatar
      alt={`${data.currentUser.firstName} ${data.currentUser.lastName}`}
      {...props}
      className={cn('h-10 w-10 rounded-full overflow-hidden', className)}
    >
      <AvatarImage source={{ uri: data.currentUser.avatarUrl }} />
      <AvatarFallback className="rounded-full">
        <Svg height="100%" width="100%" className="absolute inset-0">
          <Defs>
            <LinearGradient
              id="avatarGradient"
              x1="0%"
              y1="0%"
              x2="0%"
              y2="100%"
            >
              <Stop offset="0%" stopColor="#FFD700" />
              <Stop offset="100%" stopColor="#FFA500" />
            </LinearGradient>
          </Defs>
          <Rect
            x="0"
            y="0"
            width="100%"
            height="100%"
            fill="url(#avatarGradient)"
          />
        </Svg>
        <Text className="font-sora text-base font-bold text-[#1A1A1A] absolute">
          {initials}
        </Text>
      </AvatarFallback>
    </Avatar>
  );
};
